import { PLANS, Plan } from '../../../lib/plans'

type Props = {
  onPlanSelect: (plan: Plan) => void,
}

export const CtaStep = ({onPlanSelect}: Props) => {

  const formatPrice = (price: number) => {
    const priceParts = (price / 100).toFixed(2).split('.');
    return <>
    <div><span className="text-lg">${priceParts[0]}.</span><span className="text-xs">{priceParts[1]}</span></div>
    <span className="uppercase text-gray-300">per Month</span></>
  }

  const classNames = "m-4 rounded-md border border-transparent shadow-sm px-4 py-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
  return (
    <>
      {PLANS.map((p) => {
        return (<div key={p.external_id}>
        <h2 className="font-bold dark:text-white">{p.title}</h2>
        <div className="text-center text-sm text-gray-700 dark:text-gray-300">
          {p.description}
        </div>
        <button type="button" className={classNames}
          onClick={() => {onPlanSelect(p)}}>
            {formatPrice(p.price)}
        </button>
      </div>)
      })}
    </>
  )
}
